import React from 'react';

export default () => (
  <svg width='16' height='13' viewBox='0 0 16 13' fill='none'>
    <path d='M9.89587 1L15 6.5M15 6.5L9.89587 12M15 6.5H1' stroke='white' stroke-linecap='round' />
  </svg>
);
